import { AiFillCheckCircle } from "react-icons/ai";
import { VscError, VscWarning } from "react-icons/vsc";

import { Close, Container } from "./styles";

const Alert = ({
  message,
  title = "",
  error = false,
  warning = false,
  success = false,
  onClose,
  children,
  margin = "10px 0 25px 0",
}: IAlertProps) => {
  const errorType = { error, warning, success };

  const handleClose = () => {
    onClose();
  };

  return (
    <Container errorType={errorType} margin={margin}>
      <section className="content">
        {error ? (
          <VscError />
        ) : warning ? (
          <VscWarning />
        ) : (
          <AiFillCheckCircle className="success" />
        )}

        <section className="message">
          {title && <h1 className="title">{title}</h1>}

          {message ? (
            <h2 className="description">{message}</h2>
          ) : (
            <h2 className="description">{children}</h2>
          )}
        </section>

        <section className="close">
          <Close onClick={handleClose} />
        </section>
      </section>
    </Container>
  );
};

interface IAlertProps {
  title?: string;
  error: boolean;
  warning?: boolean;
  success?: boolean;
  children?: any;
  margin?: string;
  onClose: () => void;
  message?: string;
}

export default Alert;
